import { BoldButton } from "./buttons/BoldButton";
import { ItalicButton } from "./buttons/ItalicButton";
import { HeadingDropdown } from "./buttons/HeadingDropdown";
import { BulletedListButton } from "./buttons/BulletedListButton";
import { NumberedListButton } from "./buttons/NumberedListButton";
import { BlockquoteButton } from "./buttons/BlockquoteButton";
import { LinkButton } from "./buttons/LinkButton";
import { HighlightButton } from "./buttons/HighlightButton";
import { TableInsertButton } from "./buttons/TableInsertButton";
import { UndoButton } from "./buttons/UndoButton";
import { RedoButton } from "./buttons/RedoButton";
import {
    DeleteColumnButton,
    DeleteRowButton,
    DeleteTableButton,
    InsertColumnLeftButton,
    InsertColumnRightButton,
    InsertRowAboveButton,
    InsertRowBelowButton,
    useIsInTable,
} from "./buttons/TableActionButtons";

const Divider = () => <span className="rte-toolbar-divider" aria-hidden="true" />;

export function Toolbar() {
    const inTable = useIsInTable();

    return (
        <div className="rte-toolbar" role="toolbar" aria-label="Formatting">
            <div className="rte-toolbar-group">
                <UndoButton />
                <RedoButton />
            </div>
            <Divider />
            <HeadingDropdown />
            <Divider />
            <div className="rte-toolbar-group">
                <BoldButton />
                <ItalicButton />
                <HighlightButton />
            </div>
            <Divider />
            <div className="rte-toolbar-group">
                <BulletedListButton />
                <NumberedListButton />
            </div>
            <Divider />
            <div className="rte-toolbar-group">
                <LinkButton />
                <BlockquoteButton />
                <TableInsertButton />
            </div>
            {inTable && (
                <>
                    <Divider />
                    <div className="rte-toolbar-group">
                        <InsertRowAboveButton />
                        <InsertRowBelowButton />
                        <InsertColumnLeftButton />
                        <InsertColumnRightButton />
                        <DeleteRowButton />
                        <DeleteColumnButton />
                        <DeleteTableButton />
                    </div>
                </>
            )}
        </div>
    );
}
